import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const skillsApi = createApi({
  reducerPath: "skillsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: import.meta.env.VITE_API + "services/skills",
    prepareHeaders: (headers, { getState }) => {
      const token = getState().authSlice?.token;
      if (token) {
        headers.set("Authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }),

  // Removed tagTypes to fix the error

  endpoints: (builder) => ({
    getSkills: builder.query({
      query: (query = {}) => {
        const { filter, search } = query;
        let url = "?limit=500";

        if (filter) {
          url += `&${filter}`;
        }

        if (search) {
          url += `&title=${search}`;
        }


        return {
          url: url,
          method: "GET",
        };
      },
    }),
  }),
});

export const { useGetSkillsQuery } = skillsApi;
